import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface UnprotectedRouteProps {
  children: React.ReactNode;
}

const UnprotectedRoute: React.FC<UnprotectedRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const token = localStorage.getItem('authToken');

   // check for consent
  if (token && user && !user.consent && location.pathname !== "/consent") {
    return <Navigate to="/consent" />;
  }
  if (token && user) {
    return <Navigate to="/chat" />;
  }

  return <>{children}</>;
};

export default UnprotectedRoute;
